/**
 * Datentypen der Rechnungszuordnungs-Eigenschaften — Ersatz für
 * `typeof(ReceiptAssignment).GetProperty(FieldName).PropertyType`.
 *
 * Die Reihenfolge der Schlüssel bestimmt die Feldliste (`receiptAssignmentFieldNames`).
 */

import type { ReceiptAssignment } from '../entities';
import type { ColumnValueType } from '../fieldTypes';
import { baseEntityFieldTypes } from './base';

export const receiptAssignmentFieldTypes: Readonly<
  Record<keyof ReceiptAssignment, ColumnValueType>
> = {
  BetragContainerNetto: 'number',
  ContainerId: 'integer',
  Container: 'string',
  Container_AenderungCif: 'boolean',
  Container_Anlieferdatum: 'date',
  Container_AnlieferdatumEmpf: 'date',
  Container_AnlieferdatumIst: 'date',
  Container_Anlieferuhrzeit: 'string',
  Container_Bemerkung: 'string',
  Container_Bestellpositionen_Anzahl: 'integer',
  Container_Bestellpositionen_Artikelnummern: 'string',
  Container_Bestellpositionen_Bezeichnungen1: 'string',
  Container_Bestellpositionen_CBM: 'number',
  Container_Bestellpositionen_Mengen: 'string',
  Container_Bestellpositionen_SageBuchungDatum: 'date',
  Container_BlNummer: 'string',
  Container_Containerleerrueckgabe: 'string',
  Container_ContainerNo: 'string',
  Container_ContReturnDatum: 'date',
  Container_ContTyp: 'string',
  Container_DatumZugestellt: 'date',
  Container_DepotDatum: 'date',
  Container_DepotName: 'string',
  Container_EingangErledigt: 'boolean',
  Container_Empfaenger: 'string',
  Container_Entladedatum: 'date',
  Container_Eta: 'date',
  Container_Etd: 'date',
  Container_FruehestAnlieferdatum: 'date',
  Container_GateOutDatum: 'date',
  Container_InWochen: 'integer',
  Container_Kw: 'string',
  Container_NaechsteKw: 'boolean',
  Container_NlSp: 'string',
  Container_NlSpPos: 'string',
  Container_Plombe: 'string',
  Container_PoD: 'string',
  Container_Reeder: 'string',
  Container_RueckgabeReferenz: 'string',
  Container_Schiff: 'string',
  Container_Spediteur: 'string',
  Container_TerminBestaetigungCif: 'boolean',
  Dienstleister: 'string',
  LieferterminContainer: 'date',
  Rechnung: 'string',
  RechnungId: 'integer',
  Rechnung_ArtAufteilung: 'string',
  Rechnung_Belegdatum: 'date',
  // `Rechnung_Buchdatum` ist in der API ein String, kein DateTime.
  Rechnung_Buchdatum: 'string',
  Rechnung_DL: 'string',
  Rechnung_GesamtbetragNetto: 'number',
  Rechnung_GesamtbetragNettoEuro: 'number',
  Rechnung_Kurs: 'number',
  Rechnung_Rechnungsart: 'string',
  Rechnung_Rechnungsnummer: 'string',
  Rechnung_Wkz: 'string',
  ...baseEntityFieldTypes,
};
